import { LogHelper } from 'com-gyf-webcore-loghelper';
import { SET_CATEGORIAS } from '../../Screens/TopMenu/Actions';

const initialState = {
    categorias: []
}

export function menuCategorias(state = initialState, action) {
    LogHelper.In(menuCategorias.name, state, action);

    switch (action.type) {

        case SET_CATEGORIAS:
            LogHelper.Out(menuCategorias.name);
            return { ...state, categorias: action.data };

        default:
            LogHelper.Out(menuCategorias.name);
            return state;
    }
}

export default menuCategorias;



// WEBPACK FOOTER //
// ./Portico/App/store/Reducers/MenuCategorias.js